import { dynamicRequestReducer } from "./dynamic_request";
export const dynamicReducers = {
  dynamicRequest: dynamicRequestReducer,
};
export * from "./dynamic_request";
export * from "./graphql";
